<template>
	<div>
		<div class="bannerStyle">
			<img src="@/assets/enterprisea.jpg" />
			<img src="@/assets/enterpriseb.jpg" />
			<img src="@/assets/enterprisec.jpg" />
		</div>
		<div class="enter">
			<p class="p"><el-link href="/" :underline="false">首页</el-link> / 案例展示 </p>
			<b>案例图片</b>
			<el-row :gutter="20">
				<el-col :span="8" v-for="(item,index) in dlList" :key="index">
					<img :src="item.img" class="teamDl" @click.stop="openImg(item.img)" />
				</el-col>
			</el-row>
		</div>
		<el-dialog title="大图预览" :visible.sync="dialogVisible" v-if="dialogVisible" top="5%">
		  <div>
			  <img :src="imgView" style="width:100%;" />
		  </div>
		  <div slot="footer">
		    <el-button type="primary" size="small" @click="dialogVisible = false">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dlList: [
					{
						img: require('@/assets/al1.jpg')
					},
					{
						img: require('@/assets/al2.jpg')
					},
					{
						img: require('@/assets/al3.jpg')
					},
					{
						img: require('@/assets/al4.jpg')
					},
					{
						img: require('@/assets/al5.jpg')
					},
					{
						img: require('@/assets/al6.jpg')
					},
					{
						img: require('@/assets/al7.jpg')
					},
					{
						img: require('@/assets/al8.jpg')
					},
					{
						img: require('@/assets/al9.jpg')
					},
					{
						img: require('@/assets/ala.jpg')
					},
					{
						img: require('@/assets/alb.jpg')
					},
					{
						img: require('@/assets/alc.jpg')
					},
					{
						img: require('@/assets/ald.jpg')
					},
					{
						img: require('@/assets/ale.jpg')
					},
					{
						img: require('@/assets/alf.jpg')
					}
				],
				dialogVisible:false,
				imgView:''
			}
		},

		created() {
			const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
			if (currentPosition > 0) {
				// 如果当前位置不为零，则执行滚动操作
				this.$nextTick(() => {
					window.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
				});
			}
		},
		methods: {
			openImg(img) {
				this.dialogVisible = true;
				this.imgView = img;
			},
		},
	}
</script>
<style scoped>
	.el-row {
		display: flex;
		flex-wrap: wrap;
	}

	.enter {
		width: 950px;
		margin: 0 auto 100px auto;
		display: table;
	}
	.enter b{display:block;text-align:center;margin:20px 0 50px 0;color:#606266;}
	.enter .p {
		font-size: 14px;
		padding: 30px 0;
	}

	.enter .p a {
		font-size: 14px;
	}

	.teamDl {
		width: 100%;
		cursor: pointer;
		margin-bottom: 26px;
	}
</style>


// WEBPACK FOOTER //
// src/components/caseView.vue